import React, { Component } from 'react'
import Plyr from '../components/plyr'

class Video extends Component {

  static defaultProps = {
    videoUrl: `https://www.youtube.com/watch?v=aUpeFiXKFeY`,
  }

  _getVideoID(url) {
    if (!url) return null
    let regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    let match = url.match(regExp)
    return match && match.length > 1 && match[1]
  }

  render() {

    const { videoUrl } = this.props

    return (
      <section className='video'>
        <div className='video__inner'>
          { videoUrl !== '' &&
            <div className='video__video'>
              <Plyr
                type="youtube"
                videoId={ this._getVideoID(videoUrl) }
                autoplay={false}
                urls={{
                  youtube: {
                    api: `https://noembed.com/embed?url=${0}`
                  }
                }}
              />
            </div>
          }
        </div>
      </section>
    )
  }
}

export default Video
